var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-100 daybreak-webapp",attrs:{"id":"app"}},[_c('router-view'),_c('MobileWarningModal',{staticClass:"mobile-warning"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }